import styled from "styled-components";

export const Frame = styled.div<{ $radius: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${(p) => p.$radius}px;
  overflow: hidden;
  background: ${(p) => p.theme.tokens.colors.line};
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const Placeholder = styled.div<{ $radius: number }>`
  width: 100%;
  height: 100%;
  border-radius: ${(p) => p.$radius}px;
  overflow: hidden;
  background: ${(p) => p.theme.tokens.colors.line};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #9fb0ab;
  font-size: 9.5px;
  letter-spacing: 0.3px;
  text-transform: lowercase;
`;
